import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const Row = ({ a, reload }) => {
  const [code, setCode] = useState(a.suggested_code || "");
  const [busy, setBusy] = useState(false);
  const act = async (action) => {
    let body = {};
    if (action === "reject") {
      const reason = window.prompt(`Reject ${a.name}'s application? Optional note for the email:`, "");
      if (reason === null) return;
      body = { reason };
    } else body = { code: code.trim() || null };
    setBusy(true);
    try { await api.post(`/admin/affiliate-applications/${a.application_id}/${action}`, body); toast.success(action === "approve" ? `${a.name} is now an affiliate` : "Application rejected"); reload(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <li className="paper-card grid gap-4 p-5 lg:grid-cols-[1fr_auto]" data-testid={`application-row-${a.application_id}`}>
      <div className="space-y-1 text-base">
        <p className="text-xl font-bold">{a.name} <span className="text-base font-normal text-[#5C4A3E]">{a.email} · {a.phone}</span></p>
        <p><b>Sharing plan:</b> {a.promote}</p>
        {a.website && <p className="break-all"><b>Website:</b> {a.website}</p>}
        <p><b>Payout:</b> {a.payout_method} · <span className="text-sm text-[#8C7A6B]">Applied {new Date(a.created_at).toLocaleDateString()}</span></p>
      </div>
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center lg:flex-col lg:items-stretch">
        <label className="text-sm font-semibold" htmlFor={`code-${a.application_id}`}>Assign code</label>
        <input id={`code-${a.application_id}`} className="field !min-h-0 !py-2 !text-base" value={code} onChange={(e) => setCode(e.target.value.toLowerCase())} data-testid={`application-code-input-${a.application_id}`} />
        <button className="btn-primary !min-h-0 !py-2" disabled={busy} onClick={() => act("approve")} data-testid={`application-approve-${a.application_id}`}>Approve</button>
        <button className="btn-outline !min-h-0 !py-2" disabled={busy} onClick={() => act("reject")} data-testid={`application-reject-${a.application_id}`}>Reject</button>
      </div>
    </li>
  );
};

export const AffiliateApplications = ({ onChange }) => {
  const [rows, setRows] = useState([]);
  const load = useCallback(() => api.get("/admin/affiliate-applications", { params: { status: "pending" } }).then(({ data }) => setRows(data)), []);
  useEffect(() => { load(); }, [load]);
  const reload = () => { load(); onChange(); };
  return (
    <section data-testid="affiliate-applications">
      <h3 className="text-2xl font-bold">Applications waiting for review <span className="ml-2 rounded-full bg-[#A83232] px-3 py-0.5 text-base text-white" data-testid="applications-count">{rows.length}</span></h3>
      <p className="mt-1 text-[#5C4A3E]">People apply at <code>{window.location.origin}/affiliates</code>. Approving creates their affiliate account and emails them their link and code.</p>
      {rows.length ? <ul className="mt-4 space-y-4">{rows.map((a) => <Row key={a.application_id} a={a} reload={reload} />)}</ul> : <p className="mt-4 text-[#5C4A3E]" data-testid="applications-empty">No applications waiting.</p>}
    </section>
  );
};
